/**
 * Event Dependencies
 */
import Vue from 'vue'

/**
 * Event Bus Definition
 *
 * @param {Vue}
 */
const bus = new Vue()

export default bus



// WEBPACK FOOTER //
// ./src/events/index.js